<template>
  <div class="search-container">
    <div class="search-item">
      <a-input
        class="search-input"
        v-model:value="formState.workOrderIdList"
        size="large"
        placeholder="搜索多个工单ID用“、”隔开"
        allowClear
        @input="inputR($event, 'workOrderIdList', 5)"
      />
    </div>
    <div class="search-item">
      <a-input
        class="search-input"
        v-model:value="formState.reminder"
        size="large"
        placeholder="请输入提醒人姓名"
        allowClear
      />
    </div>
    <div class="search-item">
      <a-select
        v-model:value="formState.businessType"
        placeholder="请选择工单类型"
        style="width: 224px"
        size="large"
        allowClear
      >
        <a-select-option
          v-for="option in workOrderType"
          :value="option.eventType"
          :key="option.eventType"
        >
          {{ option.eventTypeContent }}
        </a-select-option>
      </a-select>
    </div>
    <div class="search-item">
      <a-select
        v-model:value="formState.state"
        placeholder="请选择工单状态"
        style="width: 224px"
        size="large"
        allowClear
        @change="handleChange"
      >
        <a-select-option :value="1">待分配</a-select-option>
        <a-select-option
          v-for="option in workOrderStatus"
          :value="option.value"
          :key="option.value"
        >
          {{ option.label }}
        </a-select-option>
      </a-select>
    </div>
    <div class="search-item">
      <a-select
        v-model:value="formState.stateTag"
        placeholder="请选择状态标签"
        style="width: 224px"
        size="large"
        :options="finishLabelMap[formState.state]"
        allowClear
      ></a-select>
    </div>
    <div class="search-item">
      <a-select
        v-model:value="formState.transferFlag"
        placeholder="请选择转交状态"
        style="width: 224px"
        size="large"
        :options="transferStatus"
        allowClear
      ></a-select>
    </div>
    <div class="search-item">
      <a-input
        class="search-input"
        v-model:value="formState.acceptorName"
        size="large"
        :maxlength="20"
        placeholder="请输入当前处理人"
        @input="inputR($event, 'acceptorName', 1)"
        allowClear
      />
    </div>
    <div class="search-item">
      <a-select
        v-model:value="formState.isValid"
        placeholder="有效状态"
        style="width: 224px"
        size="large"
        :options="workOrderIsValid"
        allowClear
      ></a-select>
    </div>
    <div class="search-item">
      <a-range-picker
        size="large"
        v-model:value="formState.createTime"
        :placeholder="['创建开始时间', '创建结束时间']"
        allowClear
        :showTime="showTimeObj"
        format="YYYY-MM-DD"
        class="search-picker"
        valueFormat="YYYY-MM-DD HH:mm:ss"
        :ranges="rangePresets"
        dropdownClassName="creatTime"
        :disabledDate="disabledDate"
      />
    </div>
    <div class="search-item">
      <a-range-picker
        size="large"
        v-model:value="formState.allocateTime"
        :placeholder="['分配开始时间', '分配结束时间']"
        allowClear
        :showTime="showTimeObj"
        format="YYYY-MM-DD"
        class="search-picker"
        valueFormat="YYYY-MM-DD HH:mm:ss"
        :disabledDate="disabledDate"
      />
    </div>
    <div class="search-item">
      <a-range-picker
        size="large"
        v-model:value="formState.dealTime"
        :placeholder="['处理开始时间', '处理结束时间']"
        allowClear
        :showTime="showTimeObj"
        format="YYYY-MM-DD"
        class="search-picker"
        valueFormat="YYYY-MM-DD HH:mm:ss"
        :disabledDate="disabledDate"
      />
    </div>
    <div class="search-item">
      <a-range-picker
        size="large"
        v-model:value="formState.completeTime"
        :placeholder="['结束开始时间', '结束结束时间']"
        allowClear
        :showTime="showTimeObj"
        format="YYYY-MM-DD"
        class="search-picker"
        valueFormat="YYYY-MM-DD HH:mm:ss"
        :disabledDate="disabledDate"
      />
    </div>
    <div class="search-item">
      <a-select
        v-model:value="formState.allocatedNumType"
        placeholder="被分配次数"
        style="width: 224px"
        size="large"
        :options="timesMap"
        allowClear
      ></a-select>
    </div>
    <div class="search-item">
      <a-checkbox v-model:checked="formState.allocationFlag">2小时未分配</a-checkbox>
    </div>
    <div class="search-item">
      <a-select
        v-model:value="formState.allocateTag"
        placeholder="选择工单状态标签"
        style="width: 224px"
        size="large"
        :options="statusLabelMap"
        allowClear
      ></a-select>
    </div>
    <div class="search-item" v-if="formState.allocateTag">
      <a-select
        v-model:value="formState.belongUserErpSn"
        placeholder="选择健管"
        style="width: 224px"
        size="large"
        allowClear
      >
        <a-select-option
          v-for="item in doctorAssList"
          :key="item.erpId"
          :value="item.erpId"
          :label="item.realName"
        >
          {{ item.realName }}
        </a-select-option>
      </a-select>
    </div>
    <div class="search-item">
      <a-button class="search-button" size="large" @click="resetQuery" :loading="loading">
        重置
      </a-button>
    </div>
    <div class="search-item">
      <a-button
        class="search-button"
        size="large"
        type="primary"
        @click="searchList"
        :loading="loading"
      >
        搜索
      </a-button>
    </div>
  </div>
</template>
<script setup>
import {
  transferStatus,
  workOrderStatus,
  workOrderIsValid,
  timesMap,
  statusLabelMap,
  finishLabelMap,
  rangePresets
} from './options'
import { inputRule } from '@/utils/validate'
import { ref, reactive, watch, defineProps, defineEmits } from 'vue'
import moment from 'moment'
import workOrderType from '@/views/hooks/workorderType'
import { getDoctorAssByAllocateTag } from '@/api/Todo'
import { cloneDeep } from 'lodash-es'

const props = defineProps({
  queryParams: {
    type: Object,
    required: true
  },
  loading: {
    type: Boolean,
    default: false
  }
})

const doctorAssList = ref([])
const emits = defineEmits(['searchList', 'resetQuery'])
const formState = reactive(cloneDeep(props.queryParams))
const showTimeObj = reactive({
  format: 'HH:mm:ss',
  defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
})
// 选择工单状态时把状态标签置空
const handleChange = () => {
  formState.stateTag = null
}
//控制输入规则
function inputR(e, key, type) {
  formState[key] = inputRule(e.target.value, type)
}
function resetQuery() {
  emits('resetQuery')
}
function searchList() {
  emits('searchList', cloneDeep(formState))
}

// 选择工单状态标签后，展示对应健管list
function statusLabelChange(allocateTag) {
  if (allocateTag) {
    getDoctorAssByAllocateTag({ allocateTag }).then(res => {
      doctorAssList.value = res || []
    })
  } else {
    doctorAssList.value = []
    formState.belongUserErpSn = null
  }
}
const disabledDate = current => {
  return current && current < moment('2024-1-1 00:00:00')
}

watch(
  () => props.queryParams,
  value => {
    Object.assign(formState, cloneDeep(value))
  },
  {
    deep: true,
    immediate: true
  }
)

watch(
  () => formState.allocateTag,
  allocateTag => {
    statusLabelChange(allocateTag)
  },
  {
    immediate: true
  }
)
</script>
<style lang="scss">
.creatTime .ant-calendar-footer-btn .ant-tag {
  cursor: pointer;
}
</style>
<style scoped lang="scss">
.search-container {
  padding: 10px 20px 0;
  background-color: #ffffff;
  .search-item {
    display: inline-block;
    margin-bottom: 10px;
    margin-right: 12px;
    .search-input {
      width: 224px;
    }
  }
}
</style>
